import type { ElementalFormData, ElementalType, ElementalTypeRoute } from '../types/elemental'
import { ElementalTypeEnum } from '../types/elemental'

export function getElementalType(typeId?: number, isList?: boolean) {
  if (typeId === undefined)
    return ElementalTypeEnum.unknown

  if (isList)
    return ElementalTypeEnum.List

  switch (typeId) {
    case 0:
      return ElementalTypeEnum.List
    case 1:
      return ElementalTypeEnum.Prompt
    case 2:
      return ElementalTypeEnum.Snippet
    case 3:
      return ElementalTypeEnum.Document
    case 4:
      return ElementalTypeEnum.Output
    case 5:
      return ElementalTypeEnum.Automation
    case 6:
      return ElementalTypeEnum.Course
    case 7:
      return ElementalTypeEnum.Table
    case 8:
      return ElementalTypeEnum.Cell
    case 10:
      return ElementalTypeEnum.Tag
    case 11:
      return ElementalTypeEnum.Image
    default:
      return ElementalTypeEnum.unknown
  }
}

export function getElementalTypeRoute(type: ElementalTypeEnum): ElementalTypeRoute {
  switch (type) {
    case ElementalTypeEnum.List:
      return 'list'
    case ElementalTypeEnum.Prompt:
      return 'prompt'
    case ElementalTypeEnum.Snippet:
      return 'snippet'
    case ElementalTypeEnum.Document:
      return 'document'
    case ElementalTypeEnum.Output:
      return 'output'
    case ElementalTypeEnum.Automation:
      return 'automation'
    case ElementalTypeEnum.Course:
      return 'course'
    case ElementalTypeEnum.Table:
      return 'table'
    case ElementalTypeEnum.Cell:
      return 'cell'
    case ElementalTypeEnum.Agent:
      return 'agent'
    case ElementalTypeEnum.Tag:
      return 'tag'
    case ElementalTypeEnum.Image:
      return 'image'
    default:
      return 'unknown'
  }
}

export function getElementalEnumByString(type?: string) {
  switch (type) {
    case 'list':
      return ElementalTypeEnum.List
    case 'prompt':
      return ElementalTypeEnum.Prompt
    case 'snippet':
      return ElementalTypeEnum.Snippet
    case 'document':
      return ElementalTypeEnum.Document
    case 'output':
      return ElementalTypeEnum.Output
    case 'automation':
      return ElementalTypeEnum.Automation
    case 'course':
      return ElementalTypeEnum.Course
    case 'table':
      return ElementalTypeEnum.Table
    case 'cell':
      return ElementalTypeEnum.Cell
    case 'agent':
      return ElementalTypeEnum.Agent
    case 'tag':
      return ElementalTypeEnum.Tag
    case 'image':
      return ElementalTypeEnum.Image
    default:
      return ElementalTypeEnum.unknown
  }
}

export function getElementalSection(elementalType?: ElementalType | null, section?: string, locationMatcher?: 'default' | 'advance' | 'none') {
  if (!section || !elementalType?.metadata.layout[section] || elementalType.metadata.layout[section] === 'none')
    return false

  // If locationMatcher is provided, compare with the metadata
  if (locationMatcher)
    return elementalType.metadata.layout[section] === locationMatcher

  // If no locationMatcher is provided, just return true
  return true
}

export function elementalFactory(
  elementalTypeId: ElementalTypeEnum,
  data: Partial<ElementalFormData>,
): ElementalFormData {
  return {
    description: '',
    url: '',
    avatar: '',
    elementalTypeId,
    images: {
      output: [],
      cover: [],
    },
    attachments: [],
    listIds: [],
    isPremium: false,
    isPrivate: true,
    isTutorialHidden: false,
    tutorialStep: [],
    video: '',
    priceTypeId: 1,
    priceOriginal: null,
    elementalsVisibility: 0,
    template: '',
    metadata: '{}',
    attachmentsVisibility: 0,
    ...data,
  } as ElementalFormData
}
